import { render, staticRenderFns } from "./HomepageSmallCard.vue?vue&type=template&id=4b6ac022&lang=html"
import script from "./HomepageSmallCard.vue?vue&type=script&lang=js"
export * from "./HomepageSmallCard.vue?vue&type=script&lang=js"
import style0 from "./HomepageSmallCard.vue?vue&type=style&index=0&id=4b6ac022&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports